import { render } from "./favorite-border-icon.vue?vue&type=template&id=1c4da500"
import script from "./favorite-border-icon.vue?vue&type=script&lang=js"
export * from "./favorite-border-icon.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__